import React, { Component } from 'react';
import { Container } from 'reactstrap';

import PartnersPageTalkAboutUs from "../../components/portfolio/PartnersPage/PartnersPageTalkAboutUs";
import { FormattedMessage, injectIntl } from "react-intl";
import ContentLoader from "../../components/ContentLoader";
import PartnerCard from "../../components/portfolio/PartnersPage/PartnerCard";
import MetaTags from '../../components/SEO/MetaTags'
import { handleRequestError, Request } from '../../helpers/request'
import LocaleLink from '../../components/Routes/LocaleLink'


class PartnersPage extends Component
{
    state = {
        data: null
    };

    componentDidMount() {
        Request.get('partners')
            .then((data) => this.setState({ data }))
            .catch(handleRequestError);
    }

    render() {

        const { intl } = this.props;

        return (
            <div className="partners-page">

                <MetaTags page="partners" />

                <section className="section-partner">
                    <Container>
                        <div className="partner-head">
                            <h1 className="line-heading">
                                <FormattedMessage
                                    id="portfolio.partners.title"
                                    defaultMessage="Leader du recrutement digital depuis 2009"
                                />
                            </h1>
                            <p>
                                <FormattedMessage
                                    id="portfolio.partners.subtitle"
                                    defaultMessage="Nos partenaires en parlent mieux que nous..."
                                />
                            </p>
                        </div>

                        {this.renderPartners()}

                    </Container>
                </section>

                <PartnersPageTalkAboutUs
                    left_link={'/presse'}
                    left_title={
                        intl.formatMessage({
                            id: "portfolio.partners.talk_about_us.press.label",
                            defaultMessage: "Presse"
                        })
                    }
                    left_subtitle={
                        intl.formatMessage({
                            id: "portfolio.partners.talk_about_us.press.content",
                            defaultMessage: "Ils parlent de nous ! Retrouvez les derniers articles parus dans la presse."
                        })
                    }
                    right_link={'/formulaire-partenariat'}
                    right_title={
                        intl.formatMessage({
                            id: "portfolio.partners.talk_about_us.partnership.label",
                            defaultMessage: "Partenariat"
                        })
                    }
                    right_subtitle={
                        intl.formatMessage({
                            id: "portfolio.partners.talk_about_us.partnership.content",
                            defaultMessage: "Vous êtes un incubateur, accélérateur, une école ? Discutons !"
                        })
                    }
                />

            </div>
        )
    }

    renderPartners() {

        const { data } = this.state;

        if (!data)
            return <ContentLoader/>;

        return (
            <div className="partners-block">
                <div className="partners-info">
                    <h2>
                        <FormattedMessage
                            id="portfolio.partners.clients.title"
                            defaultMessage="Nos Clients"
                        />
                    </h2>
                    <p>
                        <FormattedMessage
                            id="portfolio.partners.clients.subtitle"
                            defaultMessage="Plus d'une centaine de partenaires qui nous font confiance
                                    pour leur trouver des talents."
                        />
                    </p>
                    <LocaleLink className="btn btn-line-primary" to="/case-study">
                        <FormattedMessage
                            id="portfolio.partners.study_cases"
                            defaultMessage="Nos études de cas"
                        />
                    </LocaleLink>
                </div>
                <div className="partner-brands">
                    <ul>
                        {
                            data.map((partner, key) => {
                                return <PartnerCard partner={partner} key_as_prop={key} key={key}/>
                            })
                        }
                    </ul>
                </div>
            </div>
        )
    }
}

export default injectIntl(PartnersPage);
